<script>
import {useRoute} from "vue-router";
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import StarRating from 'vue-star-rating';
import $ from "jquery";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";


export default {
  name: "ProductsStore",
  components: {NavbarPage, LoadingPage, StarRating},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()

    store.commit('set_filter_products_store', 'delete')

    let sub_cat_id = ref(useRoute().params.sub_cat_id)
    let page_name = ref(useRoute().params.name)

    let loading = ref(false)

    let products = ref([])
    let productss = ref([])
    let item_info_cat = ref([])
    let brands = ref([])
    let stors = ref([])
    let country = ref([])
    let citys = ref([])
    // let streets = ref([])

    let input_available = ref(false)
    let input_search = ref()

    let rating = ref(null)
    let final_rating = ref({
      low: '',
      up: '',
    })
    let store_id = ref(null)
    let brand_id = ref(null)
    let place = ref({
      state_name: null,
      city_name: null,
      state_id: null,
      city_id: null,
      // street_name: null,
      // id: null,
    })
    let price_from = ref(null)
    let price_to = ref(null)
    let fichers = ref([])

    let sort = ref(null)
    let check_filter = ref(0)

    let page = ref('products')
    let page_select_place = ref('state')

    let data_filter = store.state.filter.products


    async function load_filter() {

      loading.value = true

      await FreeWorld.Heisenberg({sub_cat: sub_cat_id.value}, 'filter_store').then((result) => {

        let res = result.data
        stors.value = res.store
        brands.value = res.brand
        item_info_cat.value = res.option

        item_info_cat.value.forEach((items) => {
          items.select = null
          items.selectname = null
        })

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_filter)
      })

      await FreeWorld.Heisenberg({}, 'user/city').then((res) => {

        loading.value = false
        country.value = res.data.results

      }).catch((result) => {
        loading.value = false
        Swals.Catch(result, load_filter)
      })

    }

    load_filter()

    function load_prods(item) {

      if (item === 'filter_del') {

        input_available.value = false
        store_id.value = null
        brand_id.value = null
        price_to.value = null
        price_from.value = null
        fichers.value = null
        // place.value.id = null
        place.value.city_name = null
        place.value.city_id = null
        place.value.state_id = null
        final_rating.value.low = null
        final_rating.value.up = null
        rating.value = null
        store.commit('set_filter_products', 'delete')
        check_filter.value = 0
        item_info_cat.value.map((item)=> item.select = null)
      }


      loading.value = true
      FreeWorld.Heisenberg({sub_category: sub_cat_id.value}, 'products', true).then((result) => {

        let res = result.data
        products.value = res
        productss.value = res
        page.value = 'products'
        loading.value = false

      }).catch((result) => {

        loading.value = false
        Swals.Catch(result, () => {
          load_prods(item)
        })
      })
    }

    function chang_filter() {

      input_available.value = data_filter.mojod
      store_id.value = data_filter.storeId
      place.value = data_filter.place
      brand_id.value = data_filter.brand
      price_from.value = data_filter.lessPrice
      price_to.value = data_filter.upPrice
      final_rating.value.up = data_filter.upScore
      rating.value = data_filter.upScore
      final_rating.value.low = data_filter.lessScore
      fichers.value = data_filter.options
      sort.value = data_filter.sort_type

      set_filter()

    }

    if (data_filter == null) {
      load_prods()
    } else {
      chang_filter()
    }

    function open_sort_filter() {

      var slide = document.getElementById('slid_filter')
      var background = document.getElementById('alert_background')

      if (slide.style.height !== '40rem') {

        slide.style.height = '40rem'
        background.style.display = 'block'

      } else {

        background.style.display = 'none'
        slide.style.height = 0

      }

    }

    function select_page(item) {

      if (item == 'filter') {
        page.value = 'filter'
      } else if (item == 'prod') {
        page.value = 'products'
      }

    }

    function chek_available() {
      input_available.value = !input_available.value
    }

    let options = ref([])
    let options_dialog = ref(false)


    function select_info(item) {
      item.selectname = item.option.find((option) => option.id === item.select)?.option ?? null
    }

    function change_country(status, id, name) {

      if (status === 'state') {

        if (id !== -1) {
          country.value.forEach((item) => {
            if (id == item.id) {
              citys.value = item.city
              place.value.state_name = item.name
              return false
            }
          })
          place.value.state_id = id
          page_select_place.value = 'city'
        } else {
          place.value.state_id = id
          place.value.city_id = null
          place.value.state_name = null
          place.value.city_name = 'همه ی استان ها'
          open_select_place()
        }

      } else if (status === 'city') {

        // citys.value.forEach((item) => {
        //   if (id == item.id) {
        //     streets.value = item.street
        //   }
        // })
        // page_select_place.value = 'street'

        place.value.city_id = id
        place.value.city_name = name
        open_select_place()

      }
      // else if (status == 'all_street') {
      //   place.value.street_name = 'همه خیابان ها'
      //   data_filter.value.street_id = -1
      //   open_select_place()
      // } else if (status == 'street') {
      //   place.value.street_name = name
      //   data_filter.value.street_id = id
      //   open_select_place()
      // }

    }

    function open_select_place() {

      let alert = document.getElementById('select_state')
      let background = document.getElementById('alert_background_place')
      page_select_place.value = 'state'


      if (alert.style.display != 'block') {

        $("#select_state").removeClass('animate__fadeOut')
        $("#select_state").addClass('animate__fadeIn')
        alert.style.display = 'block'
        background.style.display = 'block'

      } else {

        if (place.value.city_name == null) {
          // place.value.street_name = null
          // place.value.id = null
          place.value.city_name = null
          place.value.city_id = null
          place.value.state_id = null
        }

        $("#select_state").addClass('animate__fadeOut')
        setTimeout(() => {
          alert.style.display = 'none'
          background.style.display = 'none'
        }, 600)

      }

    }

    function search_prod() {
      products.value = []
      productss.value.forEach((item) => {
        if (item.name.includes(input_search.value)) {
          products.value.push(item)
        }
      })
    }

    function set_filter(action, type) {

      if (action == 'sort') {

        if (type == 'all') {
          sort.value = null
        } else {
          sort.value = type
        }

      }

      fichers.value = []
      item_info_cat.value.forEach((items) => {
        if (items.select) {
          fichers.value.push({"option_id": items.select, "option_name": items.selectname})
        }
      })

      if (rating.value != null) {
        final_rating.value.low = 0
        final_rating.value.up = rating.value
      } else {
        final_rating.value.low = null
        final_rating.value.up = null
      }


      if (price_to.value !== null && price_to.value.length === 0) {
        price_to.value = null
      }
      if (price_from.value != null && price_from.value.length === 0) {
        price_from.value = null
      }
      if (price_to.value != null && price_from.value == null || price_to.value == null && price_from.value != null) {

        Swal.fire({
          text: "لطفا فیلتر قیمت را به صورت صحیح وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      } else {

        let data = {
          sub_category: sub_cat_id.value,
          mojod: input_available.value,
          storeId: store_id.value,
          // place: place.value.city_id,
          city_id: place.value.city_id,
          state_id: place.value.state_id,
          brand: brand_id.value,
          lessPrice: price_from.value,
          upPrice: price_to.value,
          upScore: final_rating.value.up,
          lessScore: final_rating.value.low,
          options: fichers.value,
          sort_type: sort.value,
        }


        loading.value = true

        FreeWorld.Heisenberg(data, 'products', true).then((result) => {

          loading.value = false
          products.value = result.data
          data.place = place.value
          store.commit('set_filter_products', data)


          let i = []
          for (var x in data) {
            // console.log(data[x])
            // console.log(x +':'+ data[x])
            if (data[x] != null) {
              i.push(data[x])
            }
          }


          if (fichers.value.length > 0) {
            check_filter.value = i.length + fichers.value.length - 5
          } else {
            check_filter.value = i.length - 5
          }

          if (input_available.value === false) check_filter.value--
          if (price_to.value != null || price_from.value != null) check_filter.value--
          if (rating.value != null) check_filter.value--
          if (sort.value != null) check_filter.value--
          if (data.city_id !== null && data.state_id !== null) check_filter.value--


          page.value = 'products'

        }).catch((result) => {

          loading.value = false
          Swals.Catch(result, () => {
            set_filter(action, type)
          })
        })
      }


    }

    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });


    return {

      load_prods,
      loading,
      sub_cat_id,
      products,
      open_sort_filter,
      sort,
      page,
      select_page,
      input_available,
      chek_available,
      stors,
      store_id,
      brands,
      brand_id,
      price_from,
      price_to,
      item_info_cat,
      select_info,
      set_filter,
      rating,
      country,
      change_country,
      page_select_place,
      citys,
      // streets,
      open_select_place,
      place,
      check_filter,
      input_search,
      search_prod,
      options,
      options_dialog,
      page_name,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div @click="open_sort_filter" id="alert_background" class="alert_background"></div>
  <div @click="open_select_place" id="alert_background_place" class="alert_background"></div>
  <div v-if="options_dialog" @click="open_alert('close')" class="alert_background"></div>
  <div dir="ltr" id="select_state" class="animate__animated px-5 mt-3 max_width">
    <div class="bg-white rounded-4 border-costom">
      <div class="bg-color-liner position-relative rounded-top-4 d-flex justify-content-center align-items-center">
        <img @click="open_select_place" class="icon_closing_filter position-absolute" style="width: 15px"
             src="../assets/img/closing.svg" alt="">
        <img class="py-4" style="width: 100px" src="../assets/img/location_white.svg" alt="">
      </div>

      <div v-if="page_select_place === 'state' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('state', -1)" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه استان ها</p>
        </div>

        <div v-for="item in country" :key="item.id" @click="change_country('state', item.id)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <div v-if="page_select_place === 'city' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">

        <div @click="change_country('city', -1 , 'همه ی شهر ها')" class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">همه شهر ها</p>
        </div>

        <div v-for="item in citys" :key="item.id" @click="change_country('city', item.id , item.name)"
             class="d-flex justify-content-between py-3">
          <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

          <p class="m-0">{{ item.name }}</p>
        </div>

      </div>

      <!--        <div v-if="page_select_place == 'street' " class="px-2 py-3 overflow-y-scroll" style="height: 400px">-->

      <!--          <div @click="change_country('all_street')" class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">همه خیابان ها</p>-->
      <!--          </div>-->

      <!--          <div v-for="item in streets" :key="item.id" @click="change_country('street', item.id , item.name)"-->
      <!--               class="d-flex justify-content-between py-3">-->
      <!--            <img class="m-0 mx-2" style="width: 8px" src="../assets/img/down-arrow.svg" alt="">-->
      <!--            <p class="m-0 font-5">{{ item.name }}</p>-->
      <!--          </div>-->

      <!--        </div>-->

    </div>
  </div>


  <div id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div style="z-index: 20" v-if="options_dialog" class="alert_info p-body">
      <div style="max-width: 870px" class="bg-white rounded-4 position-relative w-100 z-3">
        <p v-if="options.length === 0" class="p-2 text-center m-0 font-4 my-2 py-3">آیتمی برای نمایش وجود ندارد</p>
        <p v-else v-for="item in options" :key="item.id"
           @click="select_info(item.id,item.option)"
           class="p-2 text-center m-0 font-4 my-2 py-3">
          {{ item.option }}
        </p>
      </div>
    </div>


    <div v-if="page == 'products' " id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">
      <div class="div-top-arrow bg-color d-flex align-items-center ">

        <p class="m-0">{{ page_name }}</p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>

      </div>

      <br>
      <br>
      <br>
      <br>

      <div class="d-flex align-items-center justify-content-between mt-2 flex-row-reverse p-body">

        <img @click="open_sort_filter" class="icon_sort" src="../assets/img/sort_icon.svg" alt="">

        <div class="w-95">
          <input v-model="input_search" @input="search_prod"
                 class="input_search text-center bg-white font-4 rounded-pill"
                 type="text"
                 placeholder="به دنبال چه محصولی هستی؟">
        </div>

        <div @click="select_page('filter')" class="position-relative">
          <div v-if="check_filter > 0" class="position-absolute bg-danger font-6 rounded-pill py-1 px-2 text-white">
            <p class="m-0">{{ check_filter }}</p>
          </div>
          <img class="icon_setting" src="../assets/img/setting_icon.svg" alt="">
        </div>
      </div>

      <br>


      <div v-if="products.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال ثبت محصولات ...
          </p>
        </div>
      </div>

      <div v-else class="list_products p-body">
        <!--*** محصولات ***-->
        <router-link :to="{name:'DetailsProducts' , params:{sub_cat_id:sub_cat_id , prod_id:item.id}}"
                     v-for="item in products" :key="item.id"
                     class="animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black products_custom d-flex justify-content-between mb-2 shadow-costom p-body">

          <div class="position-relative animated-background rounded-4 div_img_products">

            <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg"
                 alt="">

            <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

            <div v-if="item.rating_product != null"
                 class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

              <img style="width: 1.8rem" src="../assets/img/star_gold.svg" alt="">

              <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
            </div>

          </div>


          <div class="information_products overflow-hidden">

            <p class="font-4 font-bold" :class="{'txtoverflow':item.name.length > 26}">{{ item.name }}</p>
            <div class="my-1 d-flex justify-content-start align-items-center my-2">
              <div class="d-flex ml-2 overflow-hidden align-items-center">
                <img style="width: 1.5rem" class="ml-2" src="../assets/img/shop.svg" alt="">
                <div class="overflow-hidden">
                  <p class="font-5" :class="{'txtoverflow':item.unit_name.length > 18}">{{ item.unit_name }}</p>
                </div>
              </div>
              <div v-if="item.rating_store != null" class="position-relative">
                <img style="height: 1.5rem" src="../assets/img/star_gold.svg" alt="">
                <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
              </div>
            </div>
            <div class="my-1 d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img style="width: 1.5rem" src="../assets/img/list.svg" alt="">
                <p class="font-4 mx-2">{{ item.brand }}</p>
              </div>

              <div v-if="item.count == 0" class="existence rounded-pill">
                <p class="font-color font-5 px-2 py-1">
                  ناموجود
                </p>
              </div>
            </div>

            <hr>

            <div class="price_div d-flex justify-content-between">
              <div class="d-flex">

                <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class="font-4">
                  <span class="">{{ item.price.toLocaleString() }}</span>

                  <span v-if="item.off_price == null" class="mx-1">تومان</span>
                </p>


                <p v-if="item.off_price != null" class="font-4 mx-2 font-color m-0">
                  <span class="">{{ item.off_price.toLocaleString() }}</span>

                  <span class="mx-1">تومان</span>
                </p>

              </div>


              <p v-if="item.off_price != null" class="off_percent font-5 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
            </div>
          </div>

        </router-link>

      </div>

      <br>

      <!--        *** اسلاید بار پایین ***-->

      <div id="slid_filter" class="slid_filter p-body bg-white border-costom shadow-costom">

        <div @click="open_sort_filter" class="hr_top_filter_slider rounded-pill my-3 m-auto"></div>

        <p class="font-5 text-center font-bold">
          مرتب سازی بر اساس :
        </p>
        <hr>
        <p @click="set_filter('sort' , 'all')" :class="sort == null ? 'font-color' : '' "
           class="font-4 text-center py-1">
          همه
        </p>
        <hr>
        <p @click="set_filter('sort' , 'rating_product')" :class="sort == 'rating_product' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          میزان رضایتمندی محصول
        </p>
        <hr>
        <p @click="set_filter('sort' , 'rating_store')" :class="sort == 'rating_store' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          میزان رضایتمندی فروشگاه
        </p>
        <hr>
        <p @click="set_filter('sort' , 'lowPrice')" :class="sort == 'lowPrice' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          ارزان ترین
        </p>
        <hr>
        <p @click="set_filter('sort' , 'upPrice')" :class="sort == 'upPrice' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          گران ترین
        </p>
        <hr>
        <p @click="set_filter('sort' , 'sales_number')" :class="sort == 'sales_number' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          پرفروش ترین
        </p>
        <hr>
        <p @click="set_filter('sort' , 'discount')" :class="sort == 'discount' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          پرتخفیف ترین
        </p>
        <hr>
        <p @click="set_filter('sort' , 'Visit')" :class="sort == 'Visit' ? 'font-color' : '' "
           class="font-4 text-center py-1">
          پربازدید ترین
        </p>

      </div>

    </div>

    <div v-if="page == 'filter' " id="main" :class="loading ? 'activeClass' : '' " class="bg-main" dir="ltr">

      <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">

        <div @click="load_prods('filter_del')" class="d-flex align-items-center">
          <p>
            حذف
          </p>

          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </div>

        <div class="d-flex font-4 align-items-center">
          <p>
            فیلتر محصولات
          </p>

          <img @click="select_page('prod')" class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>


      </div>
      <br>
      <br>
      <br>
      <br>

      <div class="animate__animated animate__fadeIn">


        <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">

          <div class="d-flex justify-content-between align-items-center">

            <div>
              <input @click="chek_available" v-model="input_available" id="input_available" type="checkbox">
            </div>

            <label for="input_available" class="font-4">
              فقط کالاهای موجود
            </label>

          </div>
          <hr>

          <div class="d-flex justify-content-between align-items-center">

            <div class="d-flex align-items-center w-60">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
              <select class="font-5 text-black mx-2 w-95 text-center"
                      v-model="store_id">
                <option :value="null">همه</option>
                <option v-for="item in stors" :key="item.id" :value="item.id">{{ item.unit_name }}</option>
              </select>
            </div>

            <p class="font-4">
              نام فروشگاه
            </p>
          </div>

          <hr>

          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center w-60">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

              <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2 w-95 justify-center">

                <p class="m-0 font-5 d-flex align-items-center">
                  <span v-if="place.city_name">{{ place.city_name }}</span>
                  <span v-if="place.state_name">&nbsp;-&nbsp;{{ place.state_name }}</span>
                </p>

              </div>

              <p v-else @click="open_select_place" class="m-0 mx-2 font-5 text-center w-95">
                همه
              </p>
            </div>
            <p class="m-0 font-4">
              محدوده فروشگاه
            </p>
          </div>

          <hr>

          <div class="d-flex justify-content-between align-items-center">

            <div class="d-flex align-items-center w-60">
              <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
              <select class="font-5 text-black mx-2 w-95 text-center"
                      v-model="brand_id">
                <option :value="null">همه</option>
                <option v-for="item in brands" :key="item.id" :value="item.id">{{ item.brand }}</option>
              </select>
            </div>


            <p class="font-4">
              برند
            </p>
          </div>

        </div>

        <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">
          <p class="text-end font-4">
            فیلتر قیمت
          </p>
          <br>
          <div class="d-flex justify-content-between ">
            <div class="d-flex flex-column" style="width: 48%">
              <input v-model="price_to" class="input_price border-costom" type="tel" maxlength="9" placeholder="تا"
                     onkeydown="return event.key != ' '">
              <p v-if="price_to" class="m-0 font-bold font-5 d-flex justify-content-center font-color-green">
          <span>
            تومان
          </span>
                &nbsp;
                <span>
            {{ parseInt(price_to).toLocaleString() }}
          </span>
              </p>
            </div>
            <div class="d-flex flex-column" style="width: 48%">
              <input v-model="price_from" class="input_price border-costom" type="tel" maxlength="9" placeholder="از"
                     onkeydown="return event.key != ' '">
              <p v-if="price_from" class="m-0 font-bold font-5 justify-content-center d-flex font-color-green">
          <span>
            تومان
          </span>
                &nbsp;
                <span>
            {{ parseInt(price_from).toLocaleString() }}
          </span>
              </p>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">
          <p class="text-end font-4">
            فیلتر ستاره محصولات
          </p>

          <br>

          <div class="w-100 max_width d-flex justify-content-center">
            <star-rating :star-size="35" class="position-relative overflow-hidden" :show-rating="false"
                         v-model:rating="rating" :animate="false"></star-rating>
          </div>
        </div>

        <div v-if="item_info_cat.length != 0" class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">

          <div v-for="item in item_info_cat" :key="item.id" class="">
            <div class=" d-flex justify-content-between align-items-center py-1">
              <div class="d-flex align-items-center w-50">
                <img style="width: 8px" class="mr-1" src="../assets/img/down-arrow.svg" alt="">
                <select class="font-4 w-95 text-center" v-model="item.select" @change="select_info(item)">
                  <option :value="null">همه</option>
                  <option v-for="options in item.option" :key="options.id" :value="options.id">{{
                      options.option
                    }}
                  </option>
                </select>
              </div>
              <p class="m-0 font-4">
                {{ item.name }}
              </p>
            </div>
            <hr>
          </div>
        </div>

        <div class="button_div w-100 d-flex justify-content-center">
          <v-btn @click="set_filter" class="w-60 h-75 bg-color rounded-4 border-costom text-white my-2 ">
            اعمال فیلتر
          </v-btn>
        </div>
      </div>
    </div>

  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">

    <div>

      <NavbarPage></NavbarPage>

      <br>

      <div class="d-flex justify-space-between position-relative">
        <div v-if="products.length == 0"
             class="list_products_web w-75 p-body d-flex flex-column justify-content-center align-items-center"
             style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 100px" src="../assets/img/shop_none.svg" alt="">
            <br>
            <p class="font-5">
              در حال حاضر محصولی وجود ندارد...
            </p>
          </div>
        </div>

        <div v-else class="list_products_web">
          <!--*** محصولات ***-->
          <router-link :to="{name:'DetailsProducts' , params:{sub_cat_id:sub_cat_id , prod_id:item.id}}"
                       v-for="item in products" :key="item.id"
                       class="animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black products_custom_web d-flex justify-content-between mb-3 mx-1 shadow-costom">

            <div class="position-relative animated-background rounded-4 div_img_products_web">

              <img v-if="item.pic1 == null " class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg"
                   alt="">

              <img v-else class="w-100 h-100 rounded-4" :src="item.pic1" alt="">

              <div v-if="item.rating_product != null"
                   class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

                <img style="width: 1.2rem" src="../assets/img/star_gold.svg" alt="">

                <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
              </div>

            </div>


            <div style="width: calc(100% - 10.5rem)" class="d-flex flex-column justify-content-evenly overflow-hidden">

              <p class="font-5 font-bold" :class="{'txtoverflow':item.name.length > 30}">{{ item.name }}</p>
              <div class="my-1 d-flex justify-content-start align-items-center">
                <div class="d-flex ml-2 overflow-hidden align-items-center">
                  <img style="width: 18px" class="ml-2" src="../assets/img/shop.svg" alt="">
                  <div class="overflow-hidden">
                    <p class="font-4" :class="{'txtoverflow':item.unit_name.length > 25}">{{ item.unit_name }}</p>
                  </div>
                </div>
                <div v-if="item.rating_store != null" class="position-relative">
                  <img style="height: 25px" src="../assets/img/star_gold.svg" alt="">
                  <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
                </div>
              </div>
              <div class="my-1 d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <img style="width: 18px" src="../assets/img/list.svg" alt="">
                  <p class="font-5 mx-2">{{ item.brand }}</p>
                </div>

                <div v-if="item.count == 0" class="existence rounded-pill">
                  <p class="font-color font-4 px-2 py-1">
                    ناموجود
                  </p>
                </div>
              </div>

              <hr>

              <div class="price_div d-flex justify-content-between">
                <div class="d-flex">

                  <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-5">
                    <span class="">{{ item.price.toLocaleString() }}</span>

                    <span v-if="item.off_price == null" class="mx-1">تومان</span>
                  </p>


                  <p v-if="item.off_price != null" class="font-5 mx-2 font-color m-0">
                    <span class="">{{ item.off_price.toLocaleString() }}</span>

                    <span class="mx-1">تومان</span>
                  </p>

                </div>


                <p v-if="item.off_price != null" class="off_percent font-4 rounded-pill font-color font-bold">
                  <span>%</span>
                  <span>{{ item.discount }}</span>
                </p>
              </div>
            </div>

          </router-link>
        </div>

        <div class="sidebar">
          <div class="ma-auto">
            <input v-model="input_search" @input="search_prod"
                   class="input_search text-center bg-white font-4 rounded-pill"
                   type="text"
                   placeholder="به دنبال چه محصولی هستی؟">
          </div>

          <div
              class="font-5 text-right font-bold mb-4 position-relative d-flex justify-space-between align-items-center px-4 py-2">
            <span @click="load_prods('filter_del')" class="p-2 item_hover">حذف فیلتر</span>

            <div class="position-relative">
              <span v-if="check_filter > 0" style="left: -2rem"
                    class="position-absolute bg-danger font-4 rounded-pill px-2 py-1 text-white">{{
                  check_filter
                }}</span>
              <span class="">: فیلتر ها</span>
            </div>
          </div>

          <div class="animate__animated animate__fadeIn">

            <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">

              <div class="d-flex justify-content-between align-items-center">

                <div>
                  <input @click="chek_available" v-model="input_available" id="input_available" type="checkbox">
                </div>

                <label for="input_available" class="font-5">
                  فقط کالاهای موجود
                </label>

              </div>
              <hr>

              <div class="d-flex justify-content-between align-items-center">

                <div class="d-flex align-items-center w-60">
                  <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
                  <select class="font-6 mx-2 w-95"
                          v-model="store_id">
                    <option class="font-5" :value="null">همه</option>
                    <option class="font-5" v-for="item in stors" :key="item.id" :value="item.id">{{
                        item.unit_name
                      }}
                    </option>
                  </select>
                </div>

                <p class="font-5">
                  نام فروشگاه
                </p>
              </div>

              <hr>

              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center w-60">
                  <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">

                  <div @click="open_select_place" v-if="place.city_name != null " class="d-flex ml-2 w-95 justify-center">

                    <p class="m-0 font-6 d-flex align-items-center">
                      <span v-if="place.city_name">{{ place.city_name }}</span>
                      <span v-if="place.state_name">&nbsp;-&nbsp;{{ place.state_name }}</span>
                    </p>

                  </div>

                  <p v-else @click="open_select_place" class="m-0 mx-2 text-center font-6 w-95">
                    همه
                  </p>
                </div>
                <p class="m-0 font-5">
                  محدوده فروشگاه
                </p>
              </div>

              <hr>

              <div class="d-flex justify-content-between align-items-center">

                <div class="d-flex align-items-center w-60">
                  <img style="width: 8px" src="../assets/img/down-arrow.svg" alt="">
                  <select class="font-6 w-95 mx-2" v-model="brand_id">
                    <option class="font-5" :value="null">همه</option>
                    <option class="font-5" v-for="item in brands" :key="item.id" :value="item.id">{{ item.brand }}
                    </option>
                  </select>
                </div>


                <p class="font-5">
                  برند
                </p>
              </div>

            </div>

            <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">
              <p class="text-end font-5">
                فیلتر قیمت
              </p>
              <br>
              <div class="d-flex justify-content-between ">
                <div class="d-flex flex-column" style="width: 48%">
                  <input v-model="price_to" class="input_price border-costom" type="tel" maxlength="9" placeholder="تا"
                         onkeydown="return event.key != ' '">
                  <p v-if="price_to" class="m-0 font-bold font-5 d-flex justify-content-center font-color-green">
          <span>
            تومان
          </span>
                    &nbsp;
                    <span>
            {{ parseInt(price_to).toLocaleString() }}
          </span>
                  </p>
                </div>
                <div class="d-flex flex-column" style="width: 48%">
                  <input v-model="price_from" class="input_price border-costom" type="tel" maxlength="9"
                         placeholder="از"
                         onkeydown="return event.key != ' '">
                  <p v-if="price_from" class="m-0 font-bold font-5 justify-content-center d-flex font-color-green">
          <span>
            تومان
          </span>
                    &nbsp;
                    <span>
            {{ parseInt(price_from).toLocaleString() }}
          </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">
              <p class="text-end font-5">
                فیلتر ستاره محصولات
              </p>

              <br>

              <div class="w-100 max_width d-flex justify-content-center">
                <star-rating :star-size="35" class="position-relative overflow-hidden" :show-rating="false"
                             v-model:rating="rating" :animate="false"></star-rating>
              </div>
            </div>

            <div v-if="item_info_cat.length != 0" class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">

              <div v-for="item in item_info_cat" :key="item.id" class="">
                <div class=" d-flex justify-content-between align-items-center py-1">
                  <div class="d-flex align-items-center w-50">
                    <img style="width: 8px" class="mr-1" src="../assets/img/down-arrow.svg" alt="">
                    <select class="font-6 w-95 text-center" v-model="item.select" @change="select_info(item)">
                      <option :value="null">همه</option>
                      <option v-for="options in item.option" :key="options.id" :value="options.id">{{
                          options.option
                        }}
                      </option>
                    </select>
                  </div>
                  <p class="m-0 font-5 text-center">
                    {{ item.name }}
                  </p>
                </div>
                <hr>
              </div>
            </div>

            <div class="button_div w-100 d-flex justify-content-center">
              <v-btn @click="set_filter" class="w-60 h-75 bg-color rounded-4 border-costom text-white my-2 ">
                اعمال فیلتر
              </v-btn>
            </div>

            <p class="font-5 text-right font-bold mt-7 mb-4">
              : مرتب سازی بر اساس
            </p>

            <div id="slid_filter" class="bg-white rounded-3 mt-3 py-3 shadow-costom p-body mx-3">
              <p @click="set_filter('sort' , 'all')" :class="sort == null ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                همه
              </p>
              <hr>
              <p @click="set_filter('sort' , 'rating_product')" :class="sort == 'rating_product' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                میزان رضایتمندی محصول
              </p>
              <hr>
              <p @click="set_filter('sort' , 'rating_store')" :class="sort == 'rating_store' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                میزان رضایتمندی فروشگاه
              </p>
              <hr>
              <p @click="set_filter('sort' , 'lowPrice')" :class="sort == 'lowPrice' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                ارزان ترین
              </p>
              <hr>
              <p @click="set_filter('sort' , 'upPrice')" :class="sort == 'upPrice' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                گران ترین
              </p>
              <hr>
              <p @click="set_filter('sort' , 'sales_number')" :class="sort == 'sales_number' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                پرفروش ترین
              </p>
              <hr>
              <p @click="set_filter('sort' , 'discount')" :class="sort == 'discount' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                پرتخفیف ترین
              </p>
              <hr>
              <p @click="set_filter('sort' , 'Visit')" :class="sort == 'Visit' ? 'font-color' : '' "
                 class="font-5 text-center py-1">
                پربازدید ترین
              </p>

            </div>
          </div>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped>

.svg-arrow {
  height: 15px;
  margin-left: 10px;
}

p {
  margin: 0;
}

.input_search {
  width: 100%;
  height: 60px;
  border: 1px solid #8C8C8CA0;
}

.icon_setting, .icon_sort {
  width: 55px;
}

.products_custom {
  padding: .5rem;
  width: 100%;
  background-color: white;
  min-height: 10rem;
}

.img_products {
  width: 100%;
  height: 100%;
}

.div_stars {
  left: 50%;
  transform: translate(-50%);
  bottom: -8%;
  background-color: white;
  justify-content: center;
}

.off_percent {
  padding: 5px;
  text-align: center;
  background-color: #d2d2d2;
}

.number_star {
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}

.div_img_products {
  width: 9.5rem;
  height: 9.5rem;
}

.information_products {
  direction: rtl;
  width: calc(100% - 10rem);
}

.existence {
  border: 1px solid #8C8C8CA0;
  background-color: #d2d2d2;
}

.slid_filter {
  width: 100%;
  height: 0;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  position: fixed;
  bottom: 0;
  z-index: 5;
  max-width: 500px;
  padding-left: 100px;
  padding-right: 100px;
  overflow: hidden;
  transition: 0.5s;
}

.hr_top_filter_slider {
  width: 80%;
  height: 7px;
  background-color: rgba(255, 111, 0, 0.50);
}

.alert_background {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(79, 78, 78, 0.44);
  display: none;
  z-index: 2;
}

.list_alert {
  max-height: 400px;
  overflow-y: scroll;
}

.list_alert::-webkit-scrollbar {
  display: none;
}

.v-card-text {
  width: 250px;
}

.alert_info {
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(87, 86, 86, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  z-index: 2;
  top: 0;
  left: 0;
  display: none;
}

.filter-blur {
  filter: blur(1px);
  pointer-events: none;
}

.input_price {
  text-align: center;
  width: 100%;
  height: 50px;
  border-radius: 50px;
}

.button_div {
  height: 80px;
}

.icon_closing_filter {
  top: 15px;
  left: 15px;
}

#select_state {
  display: none;
  position: fixed;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}


.sidebar {
  position: fixed;
  right: 0;
  width: 23rem;
  direction: ltr;
  height: 100%;
  overflow-y: scroll;
}

.list_products_web {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 1rem;
  width: calc(100% - 23.5rem);
}

.products_custom_web {
  padding: 1rem;
  background-color: white;
  flex-basis: 49%;
  flex-grow: 0;
}

@media (max-width: 1285px ) {
  .products_custom_web {
    min-width: 27rem;
    flex-grow: 1;
  }
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
  object-fit: cover;
}

.item_hover {
  transition: .5s;
  border-radius: 30px;
  padding: 1.5%;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color: black;
}

.item_hover:hover {
  background-color: #818285;
  color: white;
  outline: 1px solid #e15900;
}

</style>